import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';

import { ArticlePage } from './ArticlePage';
import { NotePage } from './NotePage';
import { ProfilePage } from './ProfilePage';
import NotFound from './NotFound';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
      return <ProfilePage pubkey={decoded.data} />;

    case 'nprofile':
      return <ProfilePage pubkey={decoded.data.pubkey} />;

    case 'note':
      return <NotePage id={decoded.data} />;

    case 'nevent':
      return <NotePage id={decoded.data.id} />;

    case 'naddr': {
      const { kind, pubkey, identifier: d } = decoded.data;
      return <ArticlePage kind={kind} pubkey={pubkey} identifier={d} />;
    }

    default:
      return <NotFound />;
  }
}
